import React from 'react';
import { useAppSelector } from '../store/hooks';

interface NotAuthenticatedProps {
  children?: React.ReactNode;
  className?: string;
}

// Renders its children only when the user is NOT authenticated.
const NotAuthenticated = ({ children, className }: NotAuthenticatedProps) => {
  const isAuthenticated = useAppSelector((store) => store.auth.isAuthenticated);

  if (isAuthenticated) {
    return null;
  }

  return children instanceof Array
    ? <div className={className}>{children}</div>
    : <>{children}</>;
};

export default NotAuthenticated;
